import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, inject } from "vue";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { ILostFoundDetail } from "@/domain/entities/bbs/lostFound/lostFoundDetail.types";
import { useBbsStore } from "@/stores/bbsStore";
import {
  LostFoundStatusCode,
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  ShowErrorModal,
  ShowLoadingImage,
} from "@/types";
import { useRoute } from "vue-router";
import router from "@/router";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "FoundDetail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showLoadingImage = inject(
  PROVIDE_KEY_SHOW_LOADING_IMAGE
) as ShowLoadingImage;
const removeLoadingImage = inject(
  PROVIDE_KEY_REMOVE_LOADING_IMAGE
) as RemoveLoadingImage;

const route = useRoute();
const uid = route.params.uid?.toString();

const bbsStore = useBbsStore();
const lostFoundDetail = ref<ILostFoundDetail>();
const containerWrapper = ref<HTMLElement>();

const lostFoundStatusCodeMap: Record<string, string> = {
  [LostFoundStatusCode.STORE]: "store",
  [LostFoundStatusCode.RECOVE]: "recover",
  [LostFoundStatusCode.DISCAR]: "discard",
};

const getLostFoundDetail = async () => {
  showLoadingImage();
  const result = await bbsStore.getLostFoundDetail(uid);
  removeLoadingImage();

  if (!result.isSuccess) {
    showErrorModal(
      "습득물 상세 오류",
      result.errorMessage,
      result.resultCode,
      result.errorTime
    );
    return;
  }

  if (!result.data) return;

  lostFoundDetail.value = result.data;
};

const goBack = () => {
  router.currentRoute.value.meta.willGoBack = true;
  router.back();
};

onMounted(() => {
  getLostFoundDetail();
});

const __returned__ = { showErrorModal, showLoadingImage, removeLoadingImage, route, uid, bbsStore, lostFoundDetail, containerWrapper, lostFoundStatusCodeMap, getLostFoundDetail, goBack, Page, NavigationBar, FooterButton, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})